import React, { useState } from "react";
import { TabNavItem } from "../common/components/tabs/TabNavItem";
import { TabContent } from "../common/components/tabs/TabContent";
import { SEGMENT_BZA_ID, SEGMENT_CMC_ID } from "./constants";

interface SegmentedProductPageProps {
	tabsDefinition: {
		id: string;
		title: string;
		renderContent: (tabsNav: React.ReactNode) => React.ReactNode;
	}[];
}

export default function SegmentedProductPage({
	tabsDefinition,
}: SegmentedProductPageProps) {
	const anchor =
		window.location.href.split("#").length > 1
			? window.location.href.split("#")[1]
			: null;
	const currentSegment =
		anchor === SEGMENT_BZA_ID ? SEGMENT_BZA_ID : SEGMENT_CMC_ID;
	const [activeTab, setActiveTab] = useState(currentSegment);

	const handleTabClick = (id) => {
		setActiveTab(id);
		location.hash = `#${id}`;
	};

	const tabNavItems = tabsDefinition.map((item) => {
		return (
			<TabNavItem
				key={item.id}
				id={item.id}
				title={item.title}
				activeTab={activeTab}
				setActiveTab={handleTabClick}
			/>
		);
	});

	const tabsNav = (
		<section className="section--segments-tabs container">
			<nav className="tabs-nav">
				<ul role="tablist" className="tabs-list">
					{tabNavItems}
				</ul>
			</nav>
		</section>
	);

	const tabsContent = tabsDefinition.map((item) => {
		const { id, renderContent } = item;

		return (
			<TabContent
				key={id}
				id={id}
				activeTab={activeTab}
				content={renderContent(tabsNav)}
			/>
		);
	});

	return <div className="tabs">{tabsContent}</div>;
}
